/**
 * Whether a card belongs in a card list, as far as the client can tell from a subscription event.
 * `unknown` is never a match: the list is left as it was and the customer is offered a refetch.
 */
export type CardMatch = 'match' | 'noMatch' | 'unknown';

export function toCardMatch(isMatch: boolean): CardMatch {
  return isMatch ? 'match' : 'noMatch';
}

/** Every condition has to pass: one that fails settles it, and otherwise any doubt leaves it open. */
export function getAllCardMatch(matches: CardMatch[]): CardMatch {
  if (matches.includes('noMatch')) {
    return 'noMatch';
  }
  return matches.includes('unknown') ? 'unknown' : 'match';
}

/** One condition has to pass: one that passes settles it, and otherwise any doubt leaves it open. */
export function getAnyCardMatch(matches: CardMatch[]): CardMatch {
  if (matches.includes('match')) {
    return 'match';
  }
  return matches.includes('unknown') ? 'unknown' : 'noMatch';
}
